module.exports = __webpack_public_path__ + "img/arrow-right.5374ae71.svg";